export const getCurrentYear = () => new Date().getFullYear();